import { GenericService } from './generic.service';
import { Medication } from '@/models';

export class MedicationService extends GenericService<Medication> {
  endpoint = 'v1/medications';
}
